import { SelectInput, useListContext, SelectInputProps } from 'react-admin';
import { useTheme } from '@mui/material';
import { COLORS } from '../../theme/tokens';

type FilterSelectInputProps = SelectInputProps & {
  /** Optional: specify the filter source to check (needed for ReferenceInput) */
  filterSource?: string;
};

/**
 * SelectInput wrapper that highlights with yellow background when filter is active
 *
 * Usage:
 * - Standalone: <FilterSelectInput source="enabled" ... />
 * - In ReferenceInput: <ReferenceInput source="genreId"><FilterSelectInput filterSource="genreId" ... /></ReferenceInput>
 */
export const FilterSelectInput = ({
  filterSource,
  ...props
}: FilterSelectInputProps) => {
  const { filterValues } = useListContext();
  const theme = useTheme();

  // Use filterSource if provided (for ReferenceInput), otherwise use props.source
  const sourceToCheck = filterSource || props.source;

  // Check if filter is active
  const isActive = !!filterValues[sourceToCheck];

  const activeColor =
    theme.palette.mode === 'dark'
      ? COLORS.activeFilterBackgroundDark
      : COLORS.activeFilterBackgroundLight;

  return (
    <SelectInput
      {...props}
      sx={{
        '& .MuiOutlinedInput-root': {
          backgroundColor: isActive ? activeColor : 'transparent',
          '&:hover': {
            backgroundColor: isActive ? activeColor : 'transparent',
          },
          '&.Mui-focused': {
            backgroundColor: isActive ? activeColor : 'transparent',
          },
        },
        ...props.sx,
      }}
    />
  );
};
